import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth-error',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div style="padding: 20px; max-width: 800px; margin: 50px auto;">
      <h2 style="color: #d32f2f;">Authentication Configuration Error</h2>
      
      <div style="background: #ffebee; padding: 20px; border-radius: 4px; margin: 20px 0;">
        <h3>OAuth Redirect URI Error</h3>
        <p>The redirect URI <code>http://localhost:4200/callback</code> is not registered for the client application.</p>
      </div>

      <div style="background: #e3f2fd; padding: 20px; border-radius: 4px; margin: 20px 0;">
        <h3>Possible Solutions:</h3>
        <ol>
          <li>Contact the administrator to register <code>http://localhost:4200/callback</code> as a valid redirect URI for the <code>crop.service</code> client.</li>
          <li>Use the same port as MasofaCropMonitoringWebClient if it runs on a different port.</li>
          <li>Check if there's a different client_id for development environments.</li>
        </ol>
      </div>

      <div style="background: #f5f5f5; padding: 20px; border-radius: 4px;">
        <h3>Current Configuration:</h3>
        <ul>
          <li><strong>Client ID:</strong> crop.service</li>
          <li><strong>Authority:</strong> https://auth.masofa-yer.agro.uz</li>
          <li><strong>Redirect URI:</strong> http://localhost:4200/callback</li>
          <li><strong>Audience:</strong> https://localhost:4203</li>
        </ul>
      </div>

      <div style="margin-top: 30px;">
        <button (click)="retryAuth()" style="padding: 10px 20px; background: #1976d2; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Retry Authentication
        </button>
        <button (click)="useTestToken()" style="margin-left: 10px; padding: 10px 20px; background: #388e3c; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Use Test Token
        </button>
      </div>
    </div>
  `,
  styles: [`
    code {
      background: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: monospace;
    }
  `]
})
export class AuthErrorComponent {
  retryAuth() {
    window.location.href = '/';
  }

  useTestToken() {
    window.location.href = '/test-auth';
  }
}